import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import { api } from '../../../api/client';
import styles from './AttendancePage.module.css';

export default function AttendancePage() {
  const [records, setRecords] = useState<any[]>([]);
  const [students, setStudents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [recordType, setRecordType] = useState<'ENTRY' | 'EXIT'>('ENTRY');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [showQR, setShowQR] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [attData, studentsData] = await Promise.all([
        api.get<any[]>('/api/attendance'),
        api.get<any[]>('/api/students'),
      ]);
      if (Array.isArray(attData)) setRecords(attData);
      if (Array.isArray(studentsData)) setStudents(studentsData);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRegister = async () => {
    if (!selectedStudent) return;
    setSaving(true);
    setMessage('');
    try {
      await api.post('/api/attendance', {
        studentId: selectedStudent,
        type: recordType,
        method: 'MANUAL',
      });
      setMessage(`Asistencia registrada: ${recordType === 'ENTRY' ? 'Entrada' : 'Salida'}`);
      setSelectedStudent('');
      fetchData();
    } catch (err: any) {
      setMessage(err.message);
    }
    setSaving(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Control de Asistencia</h1>
      </div>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Registros Hoy</h3>
          <p>{records.length}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Entradas</h3>
          <p>{records.filter((r) => r.type === 'ENTRY').length}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Salidas</h3>
          <p>{records.filter((r) => r.type === 'EXIT').length}</p>
        </div>
      </div>

      <div className={styles.registerCard}>
        <h2>Registrar Asistencia Manual</h2>
        {message && (
          <div className={message.includes('Error') ? styles.errorMsg : styles.successMsg}>
            {message}
          </div>
        )}
        <div className={styles.formRow}>
          <select
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            className={styles.select}
          >
            <option value="">Seleccionar Alumno</option>
            {students.map((s: any) => (
              <option key={s.id} value={s.id}>
                {s.paternalLastName}, {s.firstName}
              </option>
            ))}
          </select>
          <div className={styles.typeToggle}>
            <button
              className={`${styles.typeBtn} ${recordType === 'ENTRY' ? styles.activeType : ''}`}
              onClick={() => setRecordType('ENTRY')}
            >
              Entrada
            </button>
            <button
              className={`${styles.typeBtn} ${recordType === 'EXIT' ? styles.activeType : ''}`}
              onClick={() => setRecordType('EXIT')}
            >
              Salida
            </button>
          </div>
          <button
            onClick={handleRegister}
            disabled={saving || !selectedStudent}
            className={styles.registerBtn}
          >
            {saving ? 'Registrando...' : 'Registrar'}
          </button>
        </div>
      </div>

      <div className={styles.qrSection}>
        <h2>Credencial QR</h2>
        <p>Selecciona un alumno para generar su código QR de acceso</p>
        <div className={styles.qrRow}>
          <select
            value={showQR || ''}
            onChange={(e) => setShowQR(e.target.value || null)}
            className={styles.select}
          >
            <option value="">Seleccionar Alumno</option>
            {students.map((s: any) => (
              <option key={s.id} value={s.id}>
                {s.paternalLastName}, {s.firstName}
              </option>
            ))}
          </select>
          {showQR && (
            <div className={styles.qrDisplay}>
              <QRCodeSVG value={showQR} size={180} level="H" includeMargin />
              <p style={{ fontSize: '0.85rem', color: '#666', marginTop: 8 }}>
                ID: {showQR.slice(0, 12)}…
              </p>
            </div>
          )}
        </div>
      </div>

      <div className={styles.tableContainer}>
        <h2>Registros de Hoy</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Alumno</th>
              <th>Tipo</th>
              <th>Hora</th>
              <th>Método</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  Cargando...
                </td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  Sin registros hoy
                </td>
              </tr>
            ) : (
              records.map((r: any) => (
                <tr key={r.id}>
                  <td>
                    {r.student?.paternalLastName}, {r.student?.firstName}
                  </td>
                  <td>
                    <span className={r.type === 'ENTRY' ? styles.entryBadge : styles.exitBadge}>
                      {r.type === 'ENTRY' ? 'Entrada' : 'Salida'}
                    </span>
                  </td>
                  <td>{new Date(r.date).toLocaleTimeString()}</td>
                  <td>{r.method}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
